/**
 *
 * "Generates dropdown menu for reporting pages"
 *
 * @file   DropdownInput.js
 * @author Lateral
 * @since  2023
 */
import { Grid, Typography, Autocomplete, TextField } from '@mui/material'
import { Controller } from 'react-hook-form'
import React from 'react'

export function DropdownInput({ name, options, onDropDownChange, textLabel, control, errors, required = false }) {
  /**
   * Generates dropdown menu to use in reporting pages
   *
   * @function
   *
   * @param {string} name - Name of the menu
   * @param {object[]} options - Array of the menu items
   * @param {} onDropDownChange - Action on changing selection
   * @param {object} control - Register object
   * @param {object} errors - Errors to generate the menu
   * @param {boolean} required - If the menu is a required field
   *
   * @returns {object} - A dropdown menu
   */
  return (
    <Grid container alignItems="center" sx={{ marginBottom: '0.5em' }}>
      <Grid item xs={12} md={3}>
        <Typography variant="h5" component="h5">
          {name}
        </Typography>
      </Grid>
      <Grid item xs={12} md={9}>
        <Controller
          control={control}
          name={name}
          rules={{ required: required }}
          render={({ field: { onChange, value, ...otherFields } }) => (
            <Autocomplete
              id={name}
              options={options}
              value={options.find((item) => item.id === value) || ''}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              getOptionLabel={(data) => data?.Name || ''}
              onChange={(e, value) => {
                if (value) {
                  onChange(value.id)
                  if (onDropDownChange) {
                    onDropDownChange(e, name, value.id)
                  }
                }
              }}
              sx={{ width: '50%' }}
              {...otherFields}
              renderInput={(params) => <TextField {...params} label={textLabel} variant="standard" />}
            />
          )}
        />

        {errors[name] && <p>This field is required</p>}
      </Grid>
    </Grid>
  )
}
